import $ from 'jquery'
const url = new URL(window.location);
let loadMorePage = 1;
let noMore = false;
let loading = false;

jQuery(function($) {

  $('ul.select-list li').on('click', function () {

    $("ul.select-list li").removeClass("active");
    $(this).addClass("active");
    const selected = $(this).attr('data-value');

    fetchFilter(selected);
  });

  $(window).on('scroll', function() {
    if (!noMore && !loading) {
      if ($(window).scrollTop() + $(window).height() - 64 >=
          $('.reference-page').offset().top + $('.reference-page').height()) {
        fetchMore();
      }
    }
  })

  init();
});

const updateUrl = (params) => {

  if (params.page && params.page > 1) {
    url.searchParams.set('page', params.page);
  } else {
    url.searchParams.delete('page');
  }

  if (params.postFormat) {
    url.searchParams.set('cat', params.postFormat);
  } else {
    url.searchParams.delete('cat');
  }

  if (url.searchParams.toString()) {
    history.pushState(null, null, '?' + url.searchParams.toString());
  } else {
    history.replaceState(null, null, url.href);
  }
};

const pagination = (page, total) => {
  const list = document.createElement('ul');
  list.className = 'pagination';
  if (total > 1) {
    const prev = document.createElement('div');
    prev.classList.add('angle-left');
    if (page === 1) {
      prev.classList.add('disabled');
    } else {
      prev.onclick = function () {
        fetchPrev();
      };
    }
    list.appendChild(prev);
    for (let i = 0; i < total; i++) {
      const item = document.createElement('li');
      item.className = 'page-item';
      if (i !== page - 1) {
        item.onclick = function () {
          fetchPage(i + 1);
        };
      } else {
        item.classList.add('active');
      }

      item.innerHTML = `<span>${i + 1}</span>`;
      list.appendChild(item);
    }
    const next = document.createElement('div');
    next.classList.add('angle-right');
    if (page === total) {
      next.classList.add('disabled');
    } else {
      next.onclick = function () {
        fetchNext();
      };
    }
    list.appendChild(next);
  } else if (total === 1) {
    const item = document.createElement('li');
    item.className = 'page-item active';
    item.innerHTML = '<span>1</span>';
    list.appendChild(item);
  }
  jQuery('#custom-pagination').html(list);
};

function scrollTop() {
  const referenceSearch = document.getElementById('category__select');
  referenceSearch.scrollIntoView({ behavior: 'smooth' }, true);
}

function fetch(queryData) {

  const searchParam = {
    searchText: queryData.hasOwnProperty('searchText') ? queryData.searchText : url.searchParams.get('s'),
    category: queryData.hasOwnProperty('category') ? queryData.category : url.searchParams.get('c'),
    postFormat: queryData.hasOwnProperty('postFormat') ? queryData.postFormat : url.searchParams.get('cat'),
    page: queryData.hasOwnProperty('page') ? queryData.page : url.searchParams.get('page'),
  };

  const par = {
    search_text: searchParam.searchText,
    category: searchParam.category,
    post_format: searchParam.postFormat,
    page: searchParam.page,
  };

  updateUrl(searchParam);
  jQuery('#reference-load-more').remove();
  jQuery.ajax({
    url: ajax_params.ajax_url,
    type: 'POST',
    data: { action: 'noorreference', ...par },
    success: function(data) {
      const result = JSON.parse(data);
      jQuery('#reference-posts-wrap').html(result.content);
      pagination(searchParam.page, result.maxPage);
    },
  });
}

function fetchMore() {
  const searchParam = {
    searchText: url.searchParams.get('s'),
    category: url.searchParams.get('c'),
    postFormat: url.searchParams.get('cat'),
  };

  const par = {
    search_text: searchParam.searchText,
    category: searchParam.category,
    post_format: searchParam.postFormat,
  };

  updateUrl(searchParam);
  $('#reference-posts-wrap').append(
      '<div class="loading">' +
      '<div class="spinner-border" role="status">' +
      '<span class="visually-hidden">Loading...</span>' +
      '</div>' +
      '</div>'
  );

  $(document).ready(function () {
    jQuery.ajax({
      url: ajax_params.ajax_url,
      type: 'POST',
      async: false,
      data: {action: 'noorreference', page: loadMorePage + 1, ...par},
      success: function (data) {
        const result = JSON.parse(data);
        loadMorePage++;
        jQuery('#reference-posts-wrap').append(result.content);
        if (loadMorePage >= result.maxPage) {
          noMore = true;
        }
      },
      complete: function () {
        jQuery('#reference-posts-wrap .loading').remove();
        loading = false;
      }
    });
  })
}

function init() {
  //$('#search-text').val(url.searchParams.get('s'));
  //$(`select[name="post_format"] option[value="${url.searchParams.get('cat') || 'all'}"]`).prop('selected', true);


  $('ul.select-list li').each(function(i){
    let data = $(this).attr('data-value');
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const category = urlParams.get('cat');
    //console.log(category);
    //console.log(data);
    if(data===category){
      $(this).addClass("active");
    }
    if(category===null){
      $('ul.select-list li:first-child').addClass("active");
    }
  });

  fetch({ page: url.searchParams.get('page') || 1 });
}

function fetchPage(page) {
  fetch({ page: page });
  scrollTop();
}

function fetchPrev() {
  const currentPage = parseInt(url.searchParams.get('page')) || 1;
  if (currentPage > 1) {
    fetch({ page: currentPage - 1 });
    scrollTop();
  }
}

// eslint-disable-next-line no-unused-vars
function fetchNext() {
  const currentPage = parseInt(url.searchParams.get('page')) || 1;
  fetch({ page: currentPage + 1 });
  scrollTop();
}

function fetchFilter(postFormat) {
  loadMorePage = 1;
  noMore = false;
  if (postFormat === 'all') {
    fetch({ page: 1, postFormat: null });
  } else {
    fetch({ page: 1, postFormat: postFormat });
  }
}
